module.exports = __webpack_public_path__ + "img/矩形 150@2x.80249437.png";